import { useMutation, UseMutationResult, useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { ReplenishmentConfig, ReplenishmentConfigListResponse, ReplenishmentReportFilters, ReplenishmentReportListResponse } from '../@types/replenishmentConfig.type';
import { createReplenishmentConfig, getAllReplenishmentConfigs, getAllReplenishmentReports, getReplenishmentConfigById, updateReplenishmentConfig } from '../api/replenishmentConfig';
import { ReplenishmentConfigsKey, ReplenishmentReportsKey } from '../configs/replenishmentConfigs';
import { PaginationSettings, OrderSettings, QueryOption } from '../@types';

export const useGetReplenishmentConfigs = (queryOptions: QueryOption): UseQueryResult<ReplenishmentConfigListResponse> => {
  return useQuery({
    queryKey: [ReplenishmentConfigsKey, queryOptions.page, queryOptions.pageSize, queryOptions.filterModel],
    queryFn: () => getAllReplenishmentConfigs(queryOptions)
  });
};

export const useCreateReplenishmentConfig = (): UseMutationResult => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      const response = await createReplenishmentConfig(data);
      return response;
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [ReplenishmentConfigsKey]
      });
    }
  });
};

export const useGetReplenishmentConfigById = (id: number): UseQueryResult<ReplenishmentConfig> => {
  return useQuery({
    queryKey: [ReplenishmentConfigsKey, id],
    queryFn: () => getReplenishmentConfigById(id),
    enabled: false
  });
};

export const useUpdateReplenishmentConfig = (): UseMutationResult => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (data: any) => {
      await updateReplenishmentConfig(data.id, data);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [ReplenishmentConfigsKey]
      });
    }
  });
};

export const useGetAllReplenishmentReports = (pageSettings: PaginationSettings, orderBy?: OrderSettings, customFilters?: ReplenishmentReportFilters): UseQueryResult<ReplenishmentReportListResponse> => {
  return useQuery({
    queryKey: [ReplenishmentReportsKey, pageSettings, orderBy, customFilters],
    queryFn: () => getAllReplenishmentReports(
      pageSettings.limit,
      pageSettings.currentPage,
      orderBy,
      customFilters
    ),
    gcTime: 0,
    enabled: false
  });
};